import * as actionTypes from "../constants/orderContants";

export const orderReducers = (orders = [], action) => {
  switch (action.type) {
    case actionTypes.CREATEORDER:
      return [...orders, action.data.data];
    case actionTypes.FETCHORDERS:
      return action.payload;
    case actionTypes.FETCHORDER:
      return action.payload;
    case actionTypes.PLACESTRIPEORDER:
      return action.payload;
    default:
      return orders;
  }
};
